<template>
  <div class="header_breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in routerList"
        :key="index"
        :to="{ path:item.path||null}"
        :class="{'pitch-on':!item.path}"
        >{{item.name}}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    routerList: Array
  },

};
</script>
<style lang="less">
.header_breadcrumb {
    .pitch-on {
        user-select: none;
        // cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header-breadcrumb.vue